<template>
  <div v-if="validKeyRange">
    <h2 class="form-section-header">Key Assignments</h2>
    <div class="inline-form-group">
      <el-tag
        class="mb-10 mt-5"
        type="warning"
      >
        <i class="el-icon-warning" style="margin-right: 4px;"></i>
        Key type field is required for Yealink devices
      </el-tag>
    </div>
    <draggable v-model="keys" @change="emitKeys">
      <transition-group name="list" tag="div">
        <div
          class="list-group-item"
          v-for="(key, keyIdx) in keys"
          :key="keyIdx + 'xo(@&'"
        >
          <div v-if="keyIdx >= startKey">
            <h4 class="form-section-header">Key {{ keyIdx }}</h4>
            <div class="inline-form-group">
              <!-- KEY TYPE -->
              <el-col :span="5">
                <dads-select
                  v-model="key.type"
                  aria-placeholder="Type"
                  @change="onKeyTypeSelection(keyIdx, $event)"
                >
                  <template slot="prefix">Type</template>
                  <el-option
                    v-for="(type, typeIdx) in typeOpts"
                    :key="typeIdx"
                    :label="type.label"
                    :value="type.value"
                  />
                </dads-select>
              </el-col>
              <el-col :span="1" />
              <!-- KEY NAME -->
              <el-col :span="8">
                <dads-select
                  v-if="key.type === '16' || key.type === '1'"
                  v-model="key.name"
                  filterable
                  remote
                  allow-create
                  :remote-method="query => remoteSearchExtensionsName(query, keyIdx)"
                  @change="emitKeys"
                  placeholder="Name"
                >
                  <template slot="prefix">Name</template>
                  <el-option
                    v-for="(item, i) in key.nameOpts"
                    :key="i"
                    :label="item.name"
                    :value="item.name"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                      {{ item.number }}
                    </span>
                  </el-option>
                </dads-select>
                <el-input
                  v-else-if="key.type === '10' || key.type === '13' || key.type === '9'"
                  v-model="key.name"
                  placeholder="Name"
                  @change="emitKeys"
                >
                  <template slot="prefix">Name</template>
                </el-input>
                <el-input v-else v-model="key.name" placeholder="Name">
                  <template slot="prefix">Name</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <!-- KEY NUMBER -->
              <el-col :span="8">
                <dads-select
                  v-if="key.type === '16' || key.type === '1'"
                  v-model="key.number"
                  filterable
                  remote
                  allow-create
                  :remote-method="
                    query => remoteSearchExtensionsNumber(query, keyIdx)
                  "
                  @change="emitKeys"
                  placeholder="Number"
                >
                  <template slot="prefix">Number</template>
                  <el-option
                    v-for="(item, i) in key.numberOpts"
                    :key="i"
                    :label="item.number"
                    :value="item.number"
                  >
                    <span style="float: left">{{ item.number }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                  </el-option>
                </dads-select>
                <dads-select
                  v-else-if="key.type === '10' || key.type === '9'"
                  v-model="key.number"
                  filterable
                  placeholder="Number"
                  @change="emitKeys"
                >
                  <template slot="prefix">Number</template>
                  <el-option
                    v-for="(item, i) in parkingLot.options"
                    :key="i"
                    :label="item.value"
                    :value="item.value"
                  />
                </dads-select>
                <div
                  v-else-if="key.type === '13' || key.type === '0'"
                >
                  <el-input
                    v-model="key.number"
                    placholder="Number"
                    @change="emitKeys"
                    type="number"
                  >
                    <template slot="prefix">
                      Number
                    </template>
                  </el-input>
                </div>
                <el-input
                  v-else
                  v-model="key.number"
                  placeholder="Number"
                  @change="emitKeys"
                >
                  <template slot="prefix">Number</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="1" class="text-right">
                <el-button
                  class="table-action-button icon-blue"
                  icon="el-icon-rank"
                  style="width: 34px; height: 34px;"
                />
              </el-col>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import feathersClient from "../../../../feathers/feathers-client";

import DadsSelect from "@/components/select";
import Draggable from "vuedraggable";
export default {
  name: "KeyAssignments",

  props: {
    startKey: {
      required: true
    },
    endKey: {
      required: true
    },
    validKeyRange: { required: true },
    selectedKeys: { default: null }
  },

  components: {
    Draggable,
    DadsSelect
  },

  data() {
    return {
      typeOpts: [
        {
          label: "BLF",
          value: "16"
        },
        {
          label: "Park",
          value: "10"
        },
        {
          label: "Speed Dial",
          value: "13"
        },
        {
          label: "BLF (Grandstream)",
          value: "1"
        },
        {
          label: "Speed Dial (Grandstream)",
          value: "0"
        },
        {
          label: "Park (Grandstream)",
          value: "9"
        }
      ],
      keys: [],
      parkingLot: {
        name: "",
        options: []
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    selectedTenant(val) {
      if (val) {
        this.getParkingLotOptions();
      }
    },

    startKey: {
      immediate: true,
      handler(fresh, old) {
        if (fresh && old && this.keys.length > 0) {
          if (fresh > old) {
            for (let i = old; i < fresh; i++) {
              this.keys[old].type = "";
              this.keys[old].number = "";
              this.keys[old].numberOpts = [];
              this.keys[old].name = "";
              this.keys[old].nameOpts = [];
            }
          }
        }
        this.populateKeys();
        this.emitKeys();
      }
    },

    endKey: {
      immediate: true,
      handler(fresh, old) {
        if (old && fresh && this.keys.length > 0) {
          if (fresh > old) {
            for (let i = 0; i < fresh - old; i++) {
              this.pushKey();
            }
          } else if (old > fresh) {
            for (let i = 0; i < old - fresh; i++) {
              this.keys.pop();
            }
          }
        }

        this.populateKeys();
        this.emitKeys();
      }
    },

    validKeyRange(val) {
      if (!val) {
        this.keys = [];
      }
    },

    selectedKeys: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.keys = [...val];
          this.emitKeys();
        }
      }
    }
  },

  methods: {
    emitKeys() {
      this.$emit("keysSelected", this.keys);
    },

    pushKey() {
      this.keys.push({
        type: "",
        number: "",
        numberOpts: [],
        name: "",
        nameOpts: []
      });
    },

    populateKeys() {
      if (this.validKeyRange) {
        if (this.keys.length === 0) {
          for (let i = 0; i <= this.endKey; i++) {
            this.pushKey();
          }
        }
      }
    },

    onKeyTypeSelection() {
      this.emitKeys();
    },

    getParkingLotOptions() {
      feathersClient
        .service("parkinglots")
        .find({
          query: {
            tenantId: this.selectedTenant.id
          }
        })
        .then(res => {
          const { name, start, end } = res[0];

          this.parkingLot.name = name;
          for (let i = start; i <= end; i++) {
            this.parkingLot.options.push({
              label: `${name} - ${i}`,
              value: `${i}`
            });
          }
        });
    },

    async searchExtensions(query, sortbyName = true) {
      const searchTerm = (query + "")
        .replace(/[\\"']/g, "\\$&")
        .replace(/\u0000/g, "\\0");

      let queryTerm = {
        tenantId: this.selectedTenant.id,
        $limit: 25,
        $or: [
          { number: { $like: `%${searchTerm}%` } },
          { name: { $like: `%${searchTerm}%` } }
        ]
      };

      queryTerm.$sort = sortbyName ? { name: 1 } : { number: 1 };

      return await feathersClient.service("extensions").find({
        query: queryTerm
      });

    },

    async remoteSearchExtensionsNumber(query, keyIdx) {
      if (query && query.length) {
        const exts = await this.searchExtensions(query, false);
        this.keys[keyIdx].numberOpts = [...exts];
      }
    },

    async remoteSearchExtensionsName(query, keyIdx) {
      if (query && query.length) {
        const exts = await this.searchExtensions(query, true);
        this.keys[keyIdx].nameOpts = [...exts];
      }
    }
  },

  created() {
    this.getParkingLotOptions();
  }
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>
